import { markRaw } from 'vue'

const initialState = () => {
  const state = {
    reportQuery: {
      startDate: null,
      endDate: null,
      locations: [],
      block: null,
      forms: [],
      reportType: null,
      reportTypeChild: 'general',
      periodicity: null,
      sprint: null,
      campaign: null,
      users: [],
      creator_users: [],
      role: null,
      roles: [],
      category: null,
      category2: null,
      noLocation: true,
      byUser: false,
      groups: [],
      formsFilter: true,
      eventsFilter: true,
      actionPlansFilter: false,
      tasksGroupBy: 'assigned_to',
      group: null,
      item: null,
      format: 'json',
      formCategory: [],
      franchise_id: null,
      folders: [],
      subFolders: [],
      state: null,
      status: null,
      last_result: false,
      period: '',
      filterByRating: { min: 0, max: 100 },
      filter: false,
      // Reporte de Fotos: que evidencia entra en la matriz. Las dos arrancan encendidas para que
      // el reporte siga saliendo completo si nadie toca la configuracion (TKT-1904).
      includePhotos: true,
      includeVideos: true,
      area_id: null,
      hierarchy_site_id: null,
      hierarchy_category: null,
      hierarchy_subcategory_id: null
    },
    oldReportQuery: null,
    executiveQuery: {
      itemsOrder: 'original',
      itemShow: ['answers', 'comments', 'pictures']
    },
    loading: false,
    result: null,
    originalReports: markRaw([
      'Reporte General',
      'Reporte de Incidencias',
      'Planes de Acción',
      'Reporte Consolidado',
      'Reporte de Fotos'
    ]),
    expandedFilters: true,
    printingReport: false,
    reports: markRaw([
      { label: 'Reporte de usuario', value: 'user' },
      { label: 'Reporte de ruta', value: 'location' },
      { label: 'Reporte cuantitativo', value: 'quantitative' },
      { label: 'Reporte de puntos críticos', value: 'critical_points' },
      { label: 'Reporte Praxair', value: 'general2' },
      { label: 'Reporte de autoevaluación', value: 'self_evaluation' },
      { label: 'Reporte de arqueo', value: 'cash' },
      { label: 'Reporte de semáforo', value: 'semaphore' },
      { label: 'Reporte ejecutivo', value: 'executive' },
      { label: 'Reporte de Calidad', value: 'workday' },
      { label: 'Reporte de Responsabilidades', value: 'responsability_leadership' },
      { label: 'Auditoría Integral Calimax', value: 'calimax_workday' },
      { label: 'Reporte de Tablero', value: 'board' },
      { label: 'Reporte por Item', value: 'answers' },
      { label: 'Reporte Consolidado del Item', value: 'consolidated_answers' },
      { label: 'Reporte de Seguimiento', value: 'follow_up' },
      { label: 'Resumen Integral', value: 'category' },
      { label: 'Resumen Integral Toks', value: 'category_toks' },
      { label: 'Reporte RAC DIMSA', value: 'dimsa_rac' },
      { label: 'Evaluación de Formulario', value: 'form_by_scale' },
      { label: 'Factor de Potencia Acosta Verde', value: 'power_factor' },
      { label: 'Cumplimiento', value: 'fullfillment' },
      { label: 'Formularios por Auditor', value: 'auditor_role' },
      { label: 'Reporte de Recursos', value: 'resources' },
      { label: 'Incidencias Agrupadas', value: 'unified_incidences' },
      { label: 'Reporte de Caducidad', value: 'expiration' },
      { label: 'Reporte de Consolidación', value: 'caducity' },
      { label: 'Reporte Administrativo', value: 'management_report' },
      { label: 'Reporte de Campos Extra', value: 'extras' },
      { label: 'Resumen Detallado', value: 'finished_detail' },
      { label: 'Reporte de No Ejecución', value: 'non_executions_report' },
      { label: 'Reporte de Tablas', value: 'tables_report' },
      { label: 'Auditoría Forense Innova', value: 'forensic_audit' },
      { label: 'Reporte de Planogramas', value: 'planogram_report' },
      { label: 'Reporte de Planogramas (Calidad)', value: 'planogram_quality_report' },
      { label: 'Reporte de Planogramas (Tabla)', value: 'planogram_table_report' },
      { label: 'Modulo de Galeria', value: 'gallery_module' },
      { label: 'Reporte de Tiempos de Ejecución', value: 'execution_time' },
      { label: 'Reporte de Administración', value: 'administration_report' },
      { label: 'Reporte Seguimiento Usuario', value: 'user_tracking_report' },
      { label: 'Reporte de Voice Value', value: 'satisfaction_surveys' },
      { label: 'Reporte de Exhibiciones', value: 'exhibitions' },
      { label: 'Reporte de Asistencia', value: 'attendance' }
    ])
  }

  return state
}

export default initialState
